


































import { Component, Vue, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import Spinners from "@/components/utilities/Spinners.vue";

import getYoutubeEmbedVuexModule from "@/store/vuex-modules/getYoutubeEmbed";
const getYoutubeEmbedStore = getModule(getYoutubeEmbedVuexModule);

@Component({
    components: { Spinners }
})
export default class UpcomingStreams extends Vue {
    @Prop({
        required: true
    })
    url?: string;
    embedCode = "";
    isLoading = true;

    get getLayoutOptions(): boolean {
        return this.$store.getters.layoutOptions;
    }

    created() {
        this.handleVideoUrl();
    }

    //methods
    handleVideoUrl() {
        // TODO we can support facebook as well once this is done: https://matrix-group.atlassian.net/browse/VMP-657
        const validServices = ["youtube.com", "youtu.be", "vimeo.com"];
        let loadEmbed = false;

        for (let index = 0; index < validServices.length; index++) {
            const service = validServices[index];
            if (this.url && this.url.includes(service)) {
                loadEmbed = true;
                break;
            }
        }

        if (loadEmbed) {
            this.getVideoEmbed();
        } else {
            this.isLoading = false;
        }
    }

    getVideoEmbed() {
        const url = this.url;
        let embedService;

        if (
            (url && url.includes("youtube.com")) ||
            (url && url.includes("youtu.be"))
        ) {
            embedService = getYoutubeEmbedStore.getYoutubeEmbed;
        } else {
            embedService = Vue.prototype.MgGetVideoEmbed;
        }

        embedService(url)
            .then((html: string) => {
                this.embedCode = html;
            })
            .catch((error: Error) => {
                console.error(error);
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}
